<template>
    <div>
        <span class="time">{{ parsedTime }}</span>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Clock extends Vue {
    @Prop({ type: Number, default: 0 })
    seconds;

    get parsedTime() {
        if (!this.seconds) {
            return '--:--';
        }

        let totalSeconds = this.seconds;
        const hours = String(Math.floor(totalSeconds / 3600));
        totalSeconds %= 3600;
        const minutes = String(Math.floor(totalSeconds / 60));
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    }
}
</script>
